






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class BaseLink extends Vue {
    @Prop() to!: string

    getTo() {
        if ( typeof this.to !== 'string' ) {
            return this.to
        }

        const locale = this.$route.params.locale

        return `/${locale}/${this.to.replace( /^\/|\/$/g, "") }`
    }
}
